import { render, staticRenderFns } from "./DashboardBillPieChart.vue?vue&type=template&id=3eaf135a&scoped=true"
import script from "./DashboardBillPieChart.vue?vue&type=script&lang=js"
export * from "./DashboardBillPieChart.vue?vue&type=script&lang=js"
import style0 from "./DashboardBillPieChart.vue?vue&type=style&index=0&id=3eaf135a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3eaf135a",
  null
  
)

export default component.exports